import React, { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import {
  Button,
  CircularProgress,
  Dialog,
  InputLabel,
  Select,
  DialogActions,
  DialogContent,
  Grid,
  Hidden,
  IconButton,
  InputAdornment,
  Menu,
  MenuItem,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  FormControlLabel,
  Typography,
  FormControl,
  ExpansionPanel,
  ExpansionPanelSummary,
  ExpansionPanelDetails,
  Checkbox,
  Chip,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  Card,
  CardContent,
  CardActions,
  Tooltip,
  Divider,
  Box,
} from '@material-ui/core';
import { Field, Form, Formik } from 'formik';
import SearchIcon from '@material-ui/icons/Search';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import CallMadeIcon from '@material-ui/icons/CallMade';
import CloseIcon from '@material-ui/icons/Close';
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn';
import { useTheme } from '@material-ui/core/styles';
import CurrencyTextField from '@unicef/material-ui-currency-textfield/dist/CurrencyTextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import DeleteIcon from '@material-ui/icons/Delete';
import WarningIcon from '@material-ui/icons/Warning';
import EventIcon from '@material-ui/icons/Event';
import SelectAllIcon from '@material-ui/icons/SelectAll';
import ClearIcon from '@material-ui/icons/Clear';
import BlockIcon from '@material-ui/icons/Block';

import { isValid, format } from 'date-fns';
import useApi from '../../../utils/useApi';
import StoreContext from '../../Store/context';

import UIContainer from '../../UI/Container/UIContainer';
import UIFormTitle from '../../UI/Form/Title/UIFormTitle';
import {
  emptyObject,
  formattedCurrency,
  formattedDateTimeIso,
  goToReferenceId,
  isEqualObject,
} from '../../../utils/utils';
import UIDialogTitle from '../../UI/Dialog/Title/UIDialogTitle';
import UIButtonSearch from '../../UI/Button/Search/Search';
import UIDialogConfirm from '../../UI/Dialog/Confirm/UIDialogConfirm';
import UIFilter from '../../UI/Button/Filter/UIFilter';
import GreenSwitch from '../../UI/Form/Switch/GreenSwitch';
import UIModalFilter from '../../UI/ModalFilter/UIModalFilter';
import FormInputDate from '../../UI/Form/InputDate/FormInputDate';
import UITablePagination from '../../UI/Table/Pagination/UITablePagination';
import useStyles from '../../../utils/useStyle';

const initialState = {
  id: '',
  description: '',
  name: '',
  value: null,
  valuePaid: null,
  createdAt: null,
  dueDate: null,
  supplier: null,
};

const initialTextConfirm = {
  closeAcount: '',
  confirmPayment: '',
};

const initialPayment = {
  valuePaid: 0,
  paymentMethod: 6,
};

const initialClick = {
  mouseX: null,
  mouseY: null,
};

const BillsToPay = (children) => {
  const { referenceId } = children;
  const { credencials, setModalCashierSelect } = useContext(StoreContext);
  const { disabledTextField } = useStyles();

  // verificar se é mobile
  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [filter, setFilter] = useState(false);

  // modais de pesquisa e filtragem
  const [view, setView] = useState(false);
  const [modalValues, setModalValues] = useState({});
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  // constantes para manipular modal e valores de finalizar conta
  const [modalTerminates, setModalTerminates] = useState(false);
  const [modalBatchTerminates, setModalBatchTerminates] = useState(false);
  const [batchTerminatesLoading, setBatchTerminatesLoading] = useState(false);
  const [modalConfirmPayment, setModalConfirmPayment] = useState(false);
  const [textConfirm, setTextConfirm] = useState(initialTextConfirm);

  // paid para pesquisa
  const [paid, setPaid] = useState(false);

  // constantes para modal de pagamentos
  const [modalPay, setModalPay] = useState(false);
  const [payment, setPayment] = useState(initialPayment);
  const [alert, setAlert] = useState(false);
  const [alertUpdate, setAlertUpdate] = useState(false);
  const [alertTerminates, setAlertTerminates] = useState(false);

  // state para seleção
  const [selected, setSelected] = useState([]);
  const [isBatchPayment, setIsBatchPayment] = useState(false);

  const [search, setSearch] = useState({ paid: '0' });

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  // ação para click direito e esquerdo
  const [clickRight, setClickRight] = useState(initialClick);
  const [anchorEl, setAnchorEl] = React.useState(null);

  const [filterLoad, filterInfo, setFilterInfo] = useApi({
    debounceDelay: 500,
    method: 'get',
    url: '/bills-to-pay',
    params: { paid: '0' },
    onCompleted: (res) => {
      if (!res) {
        setFilterInfo();
      }
    },
  });

  const [updateLoad, updateInfo, setUpdateInfo] = useApi({
    method: 'put',
    url: '/bills-to-pay',
    params: { paid: '0' },
  });

  const [suppliersLoad, suppliersInfo] = useApi({
    method: 'get',
    url: '/suppliers',
  });

  const [paymentLoad, paymentInfo] = useApi({
    method: 'get',
    url: '/payments/methods',
  });

  const [payLoad, payInfo, setPayInfo] = useApi({
    method: 'patch',
    url: '/bills-to-pay',
  });

  const [terminatesLoad, terminatesInfo, setTerminatesInfo] = useApi({
    method: 'delete',
    url: '/bills-to-pay',
  });

  useEffect(() => {
    const params = referenceId
      ? { id: referenceId }
      : { paid: '0', id: referenceId };

    filterLoad({ params });
    suppliersLoad();
    paymentLoad();
    if (referenceId) {
      initialState.id = referenceId;
    }
  }, [referenceId]);

  const isSelected = (id) => selected.indexOf(id) !== -1;

  const handleClick = (event, id) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }
    setSelected(newSelected);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = filterInfo.data
        .filter((n) => n.paid !== '1')
        .map((n) => n.id);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  function handleModalFilter() {
    setFilter(!filter);
  }

  function humanAttributes(values) {
    const supplier = suppliersInfo?.data?.find(
      (value) => value.id === values.supplier,
    );
    setModalValues({
      ...values,
      supplier: supplier?.name || '..',
      dueDate: formattedDateTimeIso(values.dueDate),
    });
  }

  const handleClickRight = (event, values) => {
    event.preventDefault();
    humanAttributes(values, true);
    setClickRight({
      mouseX: event.clientX - 2,
      mouseY: event.clientY - 4,
    });
  };

  const handleCloseClickRight = () => {
    setClickRight(initialClick);
  };

  const handleCloseClickLeft = () => {
    setAnchorEl(null);
  };

  function handleModalPay(values, isClick) {
    if (values) {
      humanAttributes(values, true);
      const limitPay = Number(values.value) - Number(values.valuePaid);
      setPayment({
        ...payment,
        valuePaid: limitPay,
        limitPay,
      });
    }
    if (isClick) {
      const closeMenu = mobile ? handleCloseClickLeft : handleCloseClickRight;
      closeMenu();
    }
    setIsBatchPayment(false);
    setModalPay(!modalPay);
  }

  const handleSelectOverdue = () => {
    if (!filterInfo.data) return;
    const today = format(new Date(), 'yyyy-MM-dd');
    const overdueIds = filterInfo.data
      .filter((n) => n.paid !== '1' && n.dueDate && n.dueDate < today)
      .map((n) => n.id);
    setSelected(overdueIds);
  };

  const handleSelectDueTodayOrUpcoming = () => {
    if (!filterInfo.data) return;
    const today = format(new Date(), 'yyyy-MM-dd');
    const upcomingIds = filterInfo.data
      .filter((n) => n.paid !== '1' && (!n.dueDate || n.dueDate >= today))
      .map((n) => n.id);
    setSelected(upcomingIds);
  };

  const handleClearSelection = () => {
    setSelected([]);
  };

  const handleRemoveFromBatch = (billId) => {
    const newSelected = selected.filter((id) => id !== billId);
    setSelected(newSelected);
    if (newSelected.length === 0) {
      setModalPay(false);
      setModalBatchTerminates(false);
      setIsBatchPayment(false);
      return;
    }
    const selectedBills = filterInfo.data.filter((bill) =>
      newSelected.includes(bill.id),
    );
    const totalToPay = selectedBills.reduce(
      (acc, bill) =>
        acc + (parseFloat(bill.value) - parseFloat(bill.valuePaid)),
      0,
    );
    setModalValues({
      name: `${newSelected.length} conta(s) selecionada(s)`,
    });
    setPayment((prev) => ({
      ...prev,
      valuePaid: totalToPay,
      limitPay: totalToPay,
    }));
  };

  function handleBatchTerminates() {
    if (selected.length === 0) return;
    setModalBatchTerminates(true);
  }

  async function onBatchTerminates() {
    setBatchTerminatesLoading(true);
    for (const id of selected) {
      try {
        await terminatesLoad({ params: { id } });
      } catch (e) {
        console.error('Erro ao encerrar conta no lote:', e);
      }
    }
    setBatchTerminatesLoading(false);
    filterLoad({ params: search });
    setSelected([]);
    setModalBatchTerminates(false);
    setAlertTerminates(true);
  }

  function handleBatchPay() {
    const selectedBills = filterInfo.data.filter((bill) =>
      selected.includes(bill.id),
    );
    const totalToPay = selectedBills.reduce(
      (acc, bill) =>
        acc + (parseFloat(bill.value) - parseFloat(bill.valuePaid)),
      0,
    );

    setModalValues({
      name: `${selected.length} conta(s) selecionada(s)`,
    });
    setPayment({
      ...initialPayment,
      valuePaid: totalToPay,
      limitPay: totalToPay,
    });
    setIsBatchPayment(true);
    setModalPay(true);
  }

  function changeValuesPayment(value, attribute) {
    if (Number(value) > 0) {
      setPayment({ ...payment, [attribute]: value, errors: false });
    } else {
      setPayment({ ...payment, errors: 'Pagamento invalido' });
    }
  }

  function handleModalTerminates(values, isClick) {
    if (values) {
      humanAttributes(values);
    }
    if (isClick) {
      const closeMenu = mobile ? handleCloseClickLeft : handleCloseClickRight;
      closeMenu();
    }
    setModalTerminates(!modalTerminates);
  }

  function handleModalUpdate(values, isClick) {
    if (values) {
      humanAttributes(values);
    }
    if (isClick) {
      const closeMenu = mobile ? handleCloseClickLeft : handleCloseClickRight;
      closeMenu();
    }
    setView(!view);
  }

  function onSearch(values) {
    const searchValues = {
      ...values,
      paid: !paid && '0',
      supplier: values.supplier ? values.supplier.id : undefined,
      createdAt:
        isValid(values.createdAt) &&
        format(new Date(values.createdAt), 'yyyy-MM-dd'),
      dueDate:
        isValid(values.dueDate) &&
        format(new Date(values.dueDate), 'yyyy-MM-dd'),
    };
    filterLoad({
      debounced: true,
      params: emptyObject(searchValues),
    });
    setSearch(emptyObject(searchValues));
    setPage(0);
    setSelected([]);
  }

  function onPaid(value) {
    const searchValues = {
      ...search,
      paid: !value && '0',
    };
    filterLoad({
      params: emptyObject(searchValues),
      onCompleted: () => {
        setSearch(emptyObject(searchValues));
      },
    });
    setSelected([]);
    setPaid(value);
  }

  function onPay() {
    if (!credencials.cashSession) {
      setModalCashierSelect(true);
    } else if (Number(payment.valuePaid) > 0) {
      const idsToPay = isBatchPayment ? selected : [modalValues.id];
      const data = emptyObject({
        ids: idsToPay,
        userId: credencials.id,
        cashRegister: credencials.cashSession, // valor chumbado
        valuePaid: !isBatchPayment ? payment.valuePaid : null,
        paymentMethod: payment.paymentMethod,
      });
      payLoad({
        data,
        onCompleted: (res) => {
          setAlert(true);
          if (res) {
            setModalConfirmPayment(false);
            filterLoad({
              params: search,
            });
            setSelected([]);
            // setIsBatchPayment(false);
            // setModalPay(false);
          }
        },
      });
    }
  }

  function onUpdate(values) {
    const data = {
      id: values.id,
      dueDate:
        isValid(values.dueDate) &&
        format(new Date(values.dueDate), 'yyyy-MM-dd'),
    };
    updateLoad({
      data,
      onCompleted: (res) => {
        setAlertUpdate(!alertUpdate);
        if (res) {
          filterLoad({
            params: search,
          });
          setView(false);
        }
      },
    });
  }

  function onTerminates() {
    if (textConfirm.closeAcount === 'Encerrar conta') {
      const params = { id: modalValues.id };
      terminatesLoad({
        params,
        onCompleted: (res) => {
          setAlertUpdate(!alertUpdate);
          if (res) {
            filterLoad({
              params: search,
            });
            setAlertTerminates(true);
          }
        },
      });
    } else {
      setTextConfirm({
        ...textConfirm,
        error: 'Digite o texto corretamente para poder finalizar',
      });
    }
  }

  const today = format(new Date(), 'yyyy-MM-dd');
  const numSelected = selected.length;
  const rowCount = filterInfo.data
    ? filterInfo.data.filter((n) => n.paid !== '1').length
    : 0;
  const overdueCount = filterInfo.data
    ? filterInfo.data.filter(
        (n) => n.paid !== '1' && n.dueDate && n.dueDate < today,
      ).length
    : 0;
  const upcomingCount = filterInfo.data
    ? filterInfo.data.filter(
        (n) => n.paid !== '1' && (!n.dueDate || n.dueDate >= today),
      ).length
    : 0;

  const selectedBillsList = filterInfo.data
    ? filterInfo.data.filter((bill) => selected.includes(bill.id))
    : [];

  const totalSelectedValue = selectedBillsList.reduce(
    (acc, bill) =>
      acc + (parseFloat(bill.value) - parseFloat(bill.valuePaid)),
    0,
  );

  return (
    <>
      <Formik onSubmit={onSearch} initialValues={initialState}>
        {({ submitForm, setFieldValue, values }) => (
          <Form onChange={submitForm}>
            <UIContainer container direction="row">
              <Grid
                item
                container
                direction="row"
                justify="space-between"
                alignItems="center"
                xs={12}
              >
                <UIFormTitle title="Filtrar contas à pagar" />
                <UIFilter onClick={handleModalFilter} />
              </Grid>
              <Grid item xs={3} md={1}>
                <Field
                  name="id"
                  label="ID"
                  placeholder="ID"
                  fullWidth
                  as={TextField}
                />
              </Grid>
              <Grid item xs={9} md={3}>
                <Field
                  name="name"
                  label="Nome"
                  placeholder="Nome da conta"
                  fullWidth
                  as={TextField}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <Autocomplete
                  disableClearable
                  noOptionsText="Sem opções"
                  value={values.supplier}
                  options={
                    suppliersInfo.data !== null ? suppliersInfo.data : []
                  }
                  getOptionLabel={(option) => option.name}
                  onChange={(event, newValue) => {
                    setFieldValue('supplier', newValue);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Fornecedor"
                      name="supplier"
                      variant="standard"
                      placeholder="Informe o fornecedor"
                    />
                  )}
                />
              </Grid>
              <Hidden smDown>
                <Grid item xs={6} md={2}>
                  <FormInputDate
                    name="createdAt"
                    value={values.createdAt}
                    onChange={(value) =>
                      setFieldValue('createdAt', value, false)
                    }
                    clearable
                    label="Data de criação"
                  />
                </Grid>
                <Grid item xs={6} md={2}>
                  <FormInputDate
                    name="dueDate"
                    value={values.dueDate}
                    onChange={(value) => setFieldValue('dueDate', value, false)}
                    minDate={values.createdAt}
                    clearable
                    label="Data vencimento"
                  />
                </Grid>
                <UIButtonSearch xs={1} />
              </Hidden>
            </UIContainer>

            <UIModalFilter
              open={filter}
              changeModal={handleModalFilter}
              submit={submitForm}
            >
              <Grid item xs={12}>
                <Field
                  name="description"
                  label="Descrição"
                  placeholder="Descrição da conta"
                  fullWidth
                  as={TextField}
                />
              </Grid>
              <Hidden mdUp>
                <Grid item xs={12}>
                  <Autocomplete
                    disableClearable
                    noOptionsText="Sem opções"
                    value={values.supplier}
                    options={
                      suppliersInfo.data !== null ? suppliersInfo.data : []
                    }
                    getOptionLabel={(option) => option.name}
                    onChange={(event, newValue) => {
                      setFieldValue('supplier', newValue);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Fornecedor"
                        name="supplier"
                        variant="standard"
                        placeholder="Informe o fornecedor"
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={6} md={3}>
                  <FormInputDate
                    name="createdAt"
                    dateFormat="MM-DD-YYYY"
                    value={values.createdAt}
                    onChange={(value) =>
                      setFieldValue('createdAt', value, false)
                    }
                    clearable
                    label="Data de vencimento"
                  />
                </Grid>
                <Grid item xs={6} md={3}>
                  <FormInputDate
                    name="dueDate"
                    dateFormat="MM-DD-YYYY"
                    value={values.dueDate}
                    onChange={(value) => setFieldValue('dueDate', value, false)}
                    minDate={values.createdAt}
                    clearable
                    label="Data vencimento"
                  />
                </Grid>
              </Hidden>
              <Grid item xs={6}>
                <CurrencyTextField
                  type="tel"
                  value={values.value}
                  label="Valor da conta"
                  variant="standard"
                  decimalCharacter=","
                  digitGroupSeparator="."
                  currencySymbol="R$"
                  outputFormat="string"
                  fullWidth
                  onChange={(ev, value) => setFieldValue('value', value)}
                />
              </Grid>
              <Grid item xs={6}>
                <CurrencyTextField
                  type="tel"
                  value={values.valuePaid}
                  label="Valor da pago"
                  variant="standard"
                  decimalCharacter=","
                  digitGroupSeparator="."
                  currencySymbol="R$"
                  outputFormat="string"
                  fullWidth
                  onChange={(ev, value) => setFieldValue('valuePaid', value)}
                />
              </Grid>
            </UIModalFilter>
          </Form>
        )}
      </Formik>
      <UIContainer>
        {/* Header da Listagem */}
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          flexWrap="wrap"
          mb={2}
          style={{ gap: 12 }}
        >
          <Box display="flex" alignItems="center" flexWrap="wrap" style={{ gap: 12 }}>
            <Typography variant="h6" style={{ fontWeight: 600, color: '#182F48', margin: 0 }}>
              Contas à Pagar
            </Typography>
            <Chip
              size="small"
              label={`${(
                filterInfo?.data?.reduce(
                  (a, b) =>
                    a +
                    (b.paid == 1
                      ? 0
                      : parseFloat(b.remainingValue)),
                  0,
                ) || 0
              ).toLocaleString('pt-BR', {
                style: 'currency',
                currency: 'BRL',
              })} pendente`}
              style={{
                backgroundColor: '#FFF3E0',
                color: '#E65100',
                fontWeight: 600,
                fontSize: '0.8125rem',
                border: '1px solid #FFE0B2',
              }}
            />
          </Box>

          <Box display="flex" alignItems="center" flexWrap="wrap" style={{ gap: 8 }}>
            {numSelected > 0 && (
              <>
                <Button
                  variant="contained"
                  size="small"
                  startIcon={<MonetizationOnIcon />}
                  onClick={handleBatchPay}
                  style={{
                    background: '#17497F',
                    color: 'white',
                    fontWeight: 600,
                  }}
                >
                  Pagar {numSelected} ({formattedCurrency(totalSelectedValue)})
                </Button>
                <Button
                  variant="contained"
                  size="small"
                  startIcon={<BlockIcon />}
                  onClick={handleBatchTerminates}
                  style={{
                    background: '#C43511',
                    color: 'white',
                    fontWeight: 600,
                  }}
                >
                  Encerrar {numSelected}
                </Button>
              </>
            )}
            <FormControlLabel
              label={paid ? 'Esconder contas pagas' : 'Mostrar contas pagas'}
              labelPlacement="start"
              style={{ margin: 0 }}
              control={
                <GreenSwitch
                  checked={paid}
                  onChange={(ev) => onPaid(ev.target.checked)}
                />
              }
            />
          </Box>
        </Box>

        {/* Smart Select Toolbar Panel */}
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          flexWrap="wrap"
          style={{
            backgroundColor: '#F8F9FA',
            border: '1px solid #EAEDED',
            borderRadius: 8,
            padding: '10px 14px',
            marginBottom: 16,
            gap: 12,
          }}
        >
          <Box display="flex" alignItems="center" flexWrap="wrap" style={{ gap: 8 }}>
            <Typography variant="caption" style={{ fontWeight: 600, color: '#555', marginRight: 4 }}>
              Seleção rápida:
            </Typography>
            <Chip
              size="small"
              icon={<WarningIcon fontSize="small" style={{ color: overdueCount > 0 ? '#D32F2F' : '#9E9E9E' }} />}
              label={`Vencidas (${overdueCount})`}
              onClick={handleSelectOverdue}
              variant="outlined"
              clickable
              style={{
                borderColor: overdueCount > 0 ? '#D32F2F' : '#E0E0E0',
                color: overdueCount > 0 ? '#D32F2F' : '#666',
                backgroundColor: overdueCount > 0 ? '#FFEBEE' : '#FFF',
              }}
            />
            <Chip
              size="small"
              icon={<EventIcon fontSize="small" style={{ color: '#17497F' }} />}
              label={`A vencer (${upcomingCount})`}
              onClick={handleSelectDueTodayOrUpcoming}
              variant="outlined"
              clickable
              style={{
                borderColor: '#17497F',
                color: '#17497F',
                backgroundColor: '#E3F2FD',
              }}
            />
            <Chip
              size="small"
              icon={<SelectAllIcon fontSize="small" />}
              label={`Todas (${rowCount})`}
              onClick={() => handleSelectAllClick({ target: { checked: true } })}
              variant="outlined"
              clickable
              style={{ backgroundColor: '#FFF' }}
            />
            {numSelected > 0 && (
              <Chip
                size="small"
                icon={<ClearIcon fontSize="small" />}
                label={`Limpar seleção (${numSelected})`}
                onDelete={handleClearSelection}
                onClick={handleClearSelection}
                color="secondary"
                variant="outlined"
                clickable
                style={{ backgroundColor: '#FFF' }}
              />
            )}
          </Box>
          {numSelected > 0 && (
            <Typography variant="caption" style={{ fontWeight: 600, color: '#17497F' }}>
              {numSelected} de {rowCount} selecionada(s) • Total: {formattedCurrency(totalSelectedValue)}
            </Typography>
          )}
        </Box>

        <Grid item xs>
          {/* Visualização para Mobile (Cards) */}
          <Hidden mdUp>
            {filterInfo.loading && (
              <Box display="flex" justifyContent="center" p={3}>
                <CircularProgress />
              </Box>
            )}
            {filterInfo.data &&
              filterInfo.data
                .slice(
                  page * rowsPerPage,
                  rowsPerPage === -1
                    ? undefined
                    : page * rowsPerPage + rowsPerPage,
                )
                .map((data) => {
                  const isItemSelected = isSelected(data.id);
                  const isOverdue = data.paid !== '1' && data.dueDate && data.dueDate < today;
                  return (
                    <Card
                      key={data.id}
                      variant="outlined"
                      style={{
                        marginBottom: 12,
                        borderLeft: `4px solid ${
                          data.paid === '1'
                            ? '#9E9E9E'
                            : isOverdue
                            ? '#D32F2F'
                            : '#17497F'
                        }`,
                        backgroundColor: data.paid === '1' ? '#FAFAFA' : '#FFF',
                      }}
                    >
                      <CardContent style={{ paddingBottom: 8 }}>
                        <Box display="flex" alignItems="center" justifyContent="space-between">
                          <Box display="flex" alignItems="center">
                            <Checkbox
                              style={{ color: '#17497F', paddingLeft: 0 }}
                              checked={isItemSelected}
                              disabled={data.paid === '1'}
                              onClick={(event) => handleClick(event, data.id)}
                            />
                            <Typography variant="subtitle1" style={{ fontWeight: 'bold' }}>
                              #{data.id} {data.name}
                            </Typography>
                          </Box>
                          {data.paid === '1' ? (
                            <Chip label="Paga" size="small" style={{ backgroundColor: '#E0E0E0', color: '#616161' }} />
                          ) : isOverdue ? (
                            <Chip label="Vencida" size="small" style={{ backgroundColor: '#FFEBEE', color: '#D32F2F' }} />
                          ) : (
                            <Chip label="Pendente" size="small" style={{ backgroundColor: '#E3F2FD', color: '#17497F' }} />
                          )}
                        </Box>
                        <Box mt={1}>
                          <Typography variant="body2" color="textSecondary">
                            Fornecedor: {suppliersInfo?.data?.find((v) => v.id === data.supplier)?.name || '..'}
                          </Typography>
                          <Typography variant="body2" color="textSecondary">
                            Vencimento: {data.dueDate || 'Sem vencimento'}
                          </Typography>
                          <Box display="flex" justifyContent="space-between" mt={1}>
                            <Typography variant="body2">
                              Valor: <strong>{formattedCurrency(data.value)}</strong>
                            </Typography>
                            <Typography variant="body2">
                              Pago: <strong>{formattedCurrency(data.valuePaid)}</strong>
                            </Typography>
                          </Box>
                        </Box>
                      </CardContent>
                      <CardActions style={{ justifyContent: 'flex-end', paddingTop: 0 }}>
                        <IconButton
                          disabled={data.paid === '1'}
                          title="Finalizar conta"
                          size="small"
                          onClick={() => handleModalTerminates(data)}
                        >
                          <CloseIcon fontSize="small" />
                        </IconButton>
                        <IconButton
                          disabled={data.paid === '1'}
                          title="Pagar conta"
                          size="small"
                          onClick={() => handleModalPay(data)}
                        >
                          <MonetizationOnIcon fontSize="small" style={{ color: data.paid !== '1' ? '#17497F' : undefined }} />
                        </IconButton>
                        <IconButton
                          title="Visualizar"
                          size="small"
                          onClick={() => handleModalUpdate(data)}
                        >
                          <SearchIcon fontSize="small" />
                        </IconButton>
                      </CardActions>
                    </Card>
                  );
                })}
          </Hidden>

          {/* Visualização para Desktop (Tabela) */}
          <Hidden smDown>
            <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell padding="checkbox">
                    <Checkbox
                      style={{ color: '#17497F' }}
                      indeterminate={numSelected > 0 && numSelected < rowCount}
                      checked={rowCount > 0 && numSelected === rowCount}
                      onChange={handleSelectAllClick}
                      inputProps={{ 'aria-label': 'select all bills' }}
                    />
                  </TableCell>
                  <TableCell>ID</TableCell>
                  <TableCell>Nome</TableCell>
                  <TableCell>Fornecedor</TableCell>
                  <TableCell>Vencimento da conta</TableCell>
                  <TableCell>Valor</TableCell>
                  <TableCell>Valor pago</TableCell>
                  <TableCell>Ações</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filterInfo.loading && <CircularProgress />}
                {filterInfo.data &&
                  filterInfo.data
                    .slice(
                      page * rowsPerPage,
                      rowsPerPage === -1
                        ? undefined
                        : page * rowsPerPage + rowsPerPage,
                    )
                    .map((data) => {
                      const isItemSelected = isSelected(data.id);
                      const labelId = `enhanced-table-checkbox-${data.id}`;
                      return (
                        <TableRow
                          className="cashier-search__table-row"
                          style={{
                            cursor: 'context-menu',
                            backgroundColor:
                              (data.paid === '1' && '#EAEDED') ||
                              (data.paid === '0' && '#FFF'),
                          }}
                          tabIndex={-1}
                          onDoubleClick={() => handleModalUpdate(data)}
                          onContextMenu={
                            !mobile
                              ? (ev) => handleClickRight(ev, data)
                              : undefined
                          }
                          onClick={(ev) => handleClick(ev, data.id)}
                          key={data.id}
                          selected={isItemSelected}
                        >
                          <TableCell padding="checkbox">
                            <Checkbox
                              style={{ color: '#17497F' }}
                              checked={isItemSelected}
                              disabled={data.paid === '1'}
                              inputProps={{ 'aria-labelledby': labelId }}
                              onClick={(event) => handleClick(event, data.id)}
                            />
                          </TableCell>
                          <TableCell component="th" scope="row" id={labelId}>
                            {data.id}
                          </TableCell>
                          <TableCell>{data.name}</TableCell>
                          <TableCell>
                            {suppliersInfo?.data?.find(
                              (value) => value.id === data.supplier,
                            ).name || '..'}
                          </TableCell>
                          <TableCell>
                            {data.dueDate || 'Sem vencimento'}
                          </TableCell>
                          <TableCell>{formattedCurrency(data.value)}</TableCell>
                          <TableCell>
                            {formattedCurrency(data.valuePaid)}
                          </TableCell>
                          <TableCell>
                            <IconButton
                              disabled={data.paid === '1'}
                              title="Finalizar conta"
                              onClick={() => handleModalTerminates(data)}
                            >
                              <CloseIcon />
                            </IconButton>
                            <IconButton
                              disabled={data.paid === '1'}
                              title="Pagar conta"
                              onClick={() => handleModalPay(data)}
                            >
                              <MonetizationOnIcon />
                            </IconButton>
                            <IconButton
                              title="Visualizar"
                              onClick={() => handleModalUpdate(data)}
                            >
                              <SearchIcon />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      );
                    })}
                <Menu
                  keepMounted
                  open={clickRight.mouseY !== null}
                  onClose={handleCloseClickRight}
                  anchorReference="anchorPosition"
                  anchorPosition={
                    clickRight.mouseY !== null && clickRight.mouseX !== null
                      ? {
                        top: clickRight.mouseY,
                        left: clickRight.mouseX,
                      }
                      : undefined
                  }
                >
                  <MenuItem
                    disabled={modalValues.paid === '1'}
                    onClick={() => handleModalPay(null, true)}
                  >
                    Pagar conta
                  </MenuItem>
                  <MenuItem onClick={() => handleModalTerminates(null, true)}>
                    Finalizar conta
                  </MenuItem>
                  <MenuItem onClick={() => handleModalUpdate(null, true)}>
                    Visualizar
                  </MenuItem>
                </Menu>
                <Menu
                  id="simple-menu"
                  anchorEl={anchorEl}
                  keepMounted
                  open={Boolean(anchorEl)}
                  onClose={() => handleCloseClickLeft()}
                >
                  <MenuItem
                    disabled={modalValues.paid === '1'}
                    onClick={() => handleModalPay(null, true)}
                  >
                    Pagar conta
                  </MenuItem>
                  <MenuItem onClick={() => handleModalTerminates(null, true)}>
                    Finalizar conta
                  </MenuItem>
                  <MenuItem onClick={() => handleModalUpdate(null, true)}>
                    Visualizar
                  </MenuItem>
                </Menu>
                {filterInfo.error && (
                  <TableRow>
                    <TableCell>Sem resultados encotrados</TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
            <UITablePagination
              count={filterInfo.data ? filterInfo.data.length : 0}
              rowsPerPage={rowsPerPage}
              page={page}
              onChangePage={handleChangePage}
              onChangeRowsPerPage={handleChangeRowsPerPage}
            />
          </TableContainer>
          </Hidden>
        </Grid>
      </UIContainer>

      {/* Sticky Bottom Bar em Mobile */}
      {mobile && numSelected > 0 && (
        <Paper
          elevation={10}
          style={{
            position: 'fixed',
            bottom: 0,
            left: 0,
            right: 0,
            zIndex: 1300,
            padding: '12px 16px',
            backgroundColor: '#17497F',
            color: '#FFF',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            borderTopLeftRadius: 16,
            borderTopRightRadius: 16,
          }}
        >
          <div>
            <Typography variant="subtitle2" style={{ fontWeight: 600, color: '#FFF' }}>
              {numSelected} conta(s) selecionada(s)
            </Typography>
            <Typography variant="body2" style={{ opacity: 0.9, color: '#FFF' }}>
              Total: {formattedCurrency(totalSelectedValue)}
            </Typography>
          </div>
          <div style={{ display: 'flex', gap: 8 }}>
            <Button
              variant="contained"
              size="small"
              startIcon={<MonetizationOnIcon fontSize="small" />}
              onClick={handleBatchPay}
              style={{ backgroundColor: '#2E7D32', color: '#FFF' }}
            >
              Pagar
            </Button>
            <Button
              variant="contained"
              size="small"
              startIcon={<BlockIcon fontSize="small" />}
              onClick={handleBatchTerminates}
              style={{ backgroundColor: '#C43511', color: '#FFF' }}
            >
              Encerrar
            </Button>
          </div>
        </Paper>
      )}
      {modalValues && (
        <Dialog open={view} onClose={() => handleModalUpdate()} fullWidth>
          <Formik
            enableReinitialize
            onSubmit={onUpdate}
            initialValues={modalValues}
          >
            {({ values, submitForm, setFieldValue }) => (
              <Form>
                <UIDialogTitle
                  id="form-dialog-title"
                  onClose={() => setView(false)}
                >
                  Conta à pagar #{modalValues.id}
                </UIDialogTitle>
                <DialogContent>
                  <Grid container direction="row" spacing={1}>
                    <Grid item xs={12}>
                      <TextField
                        value={modalValues.name}
                        label="Nome"
                        fullWidth
                        className={disabledTextField}
                        disabled
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        value={modalValues.description}
                        label="Descrição"
                        fullWidth
                        className={disabledTextField}
                        disabled
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <CurrencyTextField
                        type="tel"
                        value={modalValues.value}
                        label="Valor da conta"
                        variant="standard"
                        decimalCharacter=","
                        digitGroupSeparator="."
                        currencySymbol="R$"
                        outputFormat="string"
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <CurrencyTextField
                        type="tel"
                        value={modalValues.valuePaid}
                        label="Valor pago"
                        variant="standard"
                        decimalCharacter=","
                        digitGroupSeparator="."
                        currencySymbol="R$"
                        outputFormat="string"
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        value={modalValues.supplier || '..'}
                        label="Fornecedor"
                        fullWidth
                        className={disabledTextField}
                        disabled
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        value={modalValues.referenceId}
                        label="ID da compra"
                        fullWidth
                        className={disabledTextField}
                        disabled
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <Link
                                to={() =>
                                  goToReferenceId(
                                    modalValues.referenceTable,
                                    modalValues.referenceId,
                                  )
                                }
                              >
                                <IconButton title="Ir para compra">
                                  <CallMadeIcon />
                                </IconButton>
                              </Link>
                            </InputAdornment>
                          ),
                        }}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        value={modalValues.createdAt}
                        label="Realizada"
                        fullWidth
                        className={disabledTextField}
                        disabled
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <FormInputDate
                        fullWidth
                        name="dueDate"
                        dateFormat="MM-DD-YYYY"
                        value={values.dueDate}
                        onChange={(value) =>
                          setFieldValue('dueDate', value, false)
                        }
                        clearable
                        label="Data de vencimento"
                      />
                    </Grid>
                    {modalValues.closedAt && (
                      <Grid item xs={12}>
                        <TextField
                          value={modalValues.closedAt}
                          label="Totalmente paga em"
                          fullWidth
                          className={disabledTextField}
                          disabled
                        />
                      </Grid>
                    )}
                  </Grid>
                </DialogContent>
                <DialogActions>
                  {!isEqualObject(values, modalValues) && (
                    <Button onClick={() => handleModalUpdate()} color="primary">
                      Cancelar
                    </Button>
                  )}
                  <Button
                    onClick={
                      isEqualObject(values, modalValues)
                        ? () => handleModalUpdate()
                        : () => submitForm()
                    }
                    color="primary"
                    disabled={updateInfo.loading}
                  >
                    {isEqualObject(values, modalValues) ? 'Fechar' : 'Salvar'}
                  </Button>
                </DialogActions>
              </Form>
            )}
          </Formik>
        </Dialog>
      )}
      <Dialog
        fullWidth
        open={modalPay}
        onExit={() => {
          setPayInfo();
          setPayment(initialPayment);
        }}
        onClose={() => {
          setModalPay(false);
          setIsBatchPayment(false);
        }}
      >
        <UIDialogTitle
          onClose={() => {
            setModalPay(false);
            setIsBatchPayment(false);
          }}
          id="alert-dialog-title"
        >
          Pagamento
        </UIDialogTitle>
        <DialogContent>
          <Grid container direction="row" spacing={1}>
            {isBatchPayment && !payInfo.data && (
              <Grid item xs={12}>
                <Box
                  style={{
                    backgroundColor: '#F4F6F8',
                    borderRadius: 8,
                    padding: 12,
                    marginBottom: 16,
                    border: '1px solid #E0E0E0',
                  }}
                >
                  <Typography variant="subtitle2" style={{ color: '#17497F', fontWeight: 600 }}>
                    Resumo do Lote ({selected.length} contas selecionadas)
                  </Typography>
                  <Typography variant="h6" style={{ fontWeight: 'bold', color: '#17497F', marginTop: 4 }}>
                    Total a Pagar: {formattedCurrency(payment.valuePaid)}
                  </Typography>
                </Box>
                <Typography variant="caption" style={{ fontWeight: 600, color: '#666', marginBottom: 4, display: 'block' }}>
                  Contas incluídas no lote (clique na lixeira para remover):
                </Typography>
                <List
                  dense
                  style={{
                    maxHeight: 180,
                    overflowY: 'auto',
                    border: '1px solid #E0E0E0',
                    borderRadius: 4,
                    marginBottom: 16,
                  }}
                >
                  {selectedBillsList.map((bill) => {
                    const remaining = parseFloat(bill.value) - parseFloat(bill.valuePaid);
                    const isOverdue = bill.dueDate && bill.dueDate < today;
                    return (
                      <ListItem key={bill.id} divider>
                        <ListItemText
                          primary={`#${bill.id} ${bill.name}`}
                          secondary={`Fornecedor: ${
                            suppliersInfo?.data?.find((v) => v.id === bill.supplier)?.name || '..'
                          } | Venc.: ${bill.dueDate || 'S/ Data'}`}
                          primaryTypographyProps={{ variant: 'body2', style: { fontWeight: 500 } }}
                          secondaryTypographyProps={{ variant: 'caption', style: { color: isOverdue ? '#D32F2F' : undefined } }}
                        />
                        <Box display="flex" alignItems="center">
                          <Typography variant="body2" style={{ fontWeight: 'bold', marginRight: 8 }}>
                            {formattedCurrency(remaining)}
                          </Typography>
                          <IconButton
                            size="small"
                            onClick={() => handleRemoveFromBatch(bill.id)}
                            title="Remover do lote"
                          >
                            <DeleteIcon fontSize="small" style={{ color: '#C43511' }} />
                          </IconButton>
                        </Box>
                      </ListItem>
                    );
                  })}
                </List>
              </Grid>
            )}
            {payInfo.data && console.log(payInfo.data)}
            {payInfo.data && payInfo.data.success && !isBatchPayment && (
              <TableContainer>
                <Typography align="center" variant="h6" component="div">
                  Resumo do pagamento #{payInfo.data.success[0].payment.id}
                </Typography>
                <Table size="small">
                  <TableBody>
                    <TableRow>
                      <TableCell>Pagador</TableCell>
                      <TableCell>{credencials.name}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Valor da conta</TableCell>
                      <TableCell>
                        {formattedCurrency(payInfo.data.success[0].value)}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Valor pago</TableCell>
                      <TableCell>
                        {formattedCurrency(payInfo.data.success[0].valuePaid)}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Método de pagamento</TableCell>
                      <TableCell>
                        {
                          paymentInfo.data.find(
                            (value) =>
                              value.id ===
                              payInfo.data.success[0].payment.paymentMethod,
                          ).name
                        }
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Realizada em</TableCell>
                      <TableCell>
                        {payInfo.data.success[0].payment.done}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Compra referente</TableCell>
                      <TableCell>
                        <Link
                          to={() =>
                            goToReferenceId(
                              modalValues.referenceTable,
                              payInfo.data.success[0].payment.referenceId,
                            )
                          }
                        >
                          Ver detalhes
                        </Link>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            )}
            {payInfo.data && payInfo.data.success ? (
              isBatchPayment &&
              payInfo.data.success.map((bill_payment) => (
                <ExpansionPanel square expanded>
                  <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography align="center" variant="h6" component="div">
                      Resumo do pagamento #{bill_payment.payment.id}
                    </Typography>
                  </ExpansionPanelSummary>

                  <ExpansionPanelDetails>
                    <TableContainer>
                      <Table size="small">
                        <TableBody>
                          <TableRow>
                            <TableCell>Pagador</TableCell>
                            <TableCell>{credencials.name}</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>Valor da conta</TableCell>
                            <TableCell>
                              {formattedCurrency(bill_payment.value)}
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>Valor pago</TableCell>
                            <TableCell>
                              {formattedCurrency(bill_payment.valuePaid)}
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>Método de pagamento</TableCell>
                            <TableCell>
                              {
                                paymentInfo.data.find(
                                  (value) =>
                                    value.id ===
                                    bill_payment.payment.paymentMethod,
                                ).name
                              }
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>Realizada em</TableCell>
                            <TableCell>{bill_payment.payment.done}</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>Compra referente</TableCell>
                            <TableCell>
                              <Link
                                to={() =>
                                  goToReferenceId(
                                    modalValues.referenceTable,
                                    bill_payment.payment.referenceId,
                                  )
                                }
                              >
                                Ver detalhes
                              </Link>
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </ExpansionPanelDetails>
                </ExpansionPanel>
              ))
            ) : (
              <>
                <Grid item xs={12} md={6}>
                  <FormControl fullWidth>
                    <InputLabel shrink id="bills-to-pay__paymentMethod">
                      Método de pagamento
                    </InputLabel>
                    <Select
                      value={payment.paymentMethod}
                      onChange={(ev) =>
                        changeValuesPayment(ev.target.value, 'paymentMethod')
                      }
                      labelId="bills-to-pay__paymentMethod"
                      displayEmpty
                    >
                      {paymentInfo.data &&
                        paymentInfo.data.map((pay) => (
                          <MenuItem key={pay.id} value={pay.id}>
                            {pay.name}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={6}>
                  <CurrencyTextField
                    type="tel"
                    value={payment.valuePaid}
                    error={Boolean(payment.errors)}
                    helperText={payment.errors}
                    label="Valor"
                    variant="standard"
                    decimalCharacter=","
                    digitGroupSeparator="."
                    currencySymbol="R$"
                    outputFormat="string"
                    onChange={(ev, value) =>
                      changeValuesPayment(value, 'valuePaid')
                    }
                    fullWidth
                    disabled={isBatchPayment}
                    className={isBatchPayment ? disabledTextField : ''}
                  />
                </Grid>
                {Number(payment.limitPay) < Number(payment.valuePaid) &&
                  !isBatchPayment && (
                    <Typography
                      style={{
                        color: 'rgb(196, 53, 17)',
                        fontSize: 14,
                        marginTop: 10,
                      }}
                      paragraph
                    >
                      Atenção: O valor que está informando é maior que o
                      restante à ser pago na conta, assim fazendo com que a
                      cobrança fique maior. Verifique se o mesmo está correto
                      antes de continuar
                    </Typography>
                  )}
              </>
            )}
          </Grid>
        </DialogContent>
        <DialogActions>
          {payInfo.data ? (
            <Button
              onClick={() => {
                setModalPay(false);
                setIsBatchPayment(false);
              }}
              color="primary"
              autoFocus
            >
              Sair
            </Button>
          ) : (
            <>
              <Button
                onClick={() => {
                  setModalPay(false);
                  setIsBatchPayment(false);
                }}
                color="primary"
              >
                Cancelar
              </Button>
              <Button
                onClick={
                  Number(payment.valuePaid) <= Number(payment.limitPay) ||
                    isBatchPayment
                    ? onPay
                    : () => setModalConfirmPayment(true)
                }
                color="primary"
                autoFocus
                disabled={payInfo.loading}
              >
                {payInfo.loading && <CircularProgress />} Pagar
              </Button>
            </>
          )}
        </DialogActions>
      </Dialog>
      <Dialog
        fullWidth
        open={modalTerminates}
        onExit={() => {
          setTerminatesInfo();
          setTextConfirm(initialTextConfirm);
        }}
        onClose={() => setModalTerminates(false)}
      >
        <UIDialogTitle
          onClose={() => setModalTerminates(false)}
          id="alert-dialog-title"
        >
          Atenção: valor total de pagamento ainda não foi atingido
        </UIDialogTitle>
        <DialogContent>
          <Grid container direction="row" spacing={1}>
            {terminatesInfo.data ? (
              <TableContainer>
                <Table size="small">
                  <TableBody>
                    <TableRow>
                      <TableCell>Valor da conta</TableCell>
                      <TableCell>
                        {formattedCurrency(terminatesInfo.data.bill.value)}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Valor pago</TableCell>
                      <TableCell>
                        {formattedCurrency(terminatesInfo.data.bill.valuePaid)}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Finalizado em</TableCell>
                      <TableCell>{terminatesInfo.data.bill.closedAt}</TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            ) : (
              <>
                <Typography paragraph>
                  Encerrando esta conta agora, não será possível informar mais
                  pagamentos da mesma. Para continuar, digite{' '}
                  <strong>Encerrar conta</strong> no campo abaixo:
                </Typography>
                <TextField
                  value={textConfirm.closeAcount}
                  label="Digite o texto"
                  placeholder="Encerrar conta"
                  helperText={textConfirm.error}
                  error={!!textConfirm.error}
                  onChange={(ev) =>
                    setTextConfirm({ closeAcount: ev.target.value })
                  }
                  fullWidth
                />
              </>
            )}
          </Grid>
        </DialogContent>
        <DialogActions>
          {terminatesInfo.data ? (
            <Button
              onClick={() => setModalTerminates(false)}
              color="primary"
              autoFocus
            >
              Sair
            </Button>
          ) : (
            <>
              <Button onClick={() => setModalTerminates(false)} color="primary">
                Cancelar
              </Button>
              <Button
                onClick={onTerminates}
                disabled={textConfirm.closeAcount !== 'Encerrar conta'}
                color="primary"
                autoFocus
              >
                Ok, encerrar
              </Button>
            </>
          )}
        </DialogActions>
      </Dialog>
      <Dialog
        fullWidth
        open={modalConfirmPayment}
        onExit={() => {
          setTerminatesInfo();
          setTextConfirm(initialTextConfirm);
        }}
        onClose={() => setModalConfirmPayment(false)}
      >
        <UIDialogTitle
          onClose={() => setModalConfirmPayment(false)}
          id="alert-dialog-title"
        >
          Atenção
        </UIDialogTitle>
        <DialogContent>
          <Grid container direction="row" spacing={1}>
            <Typography paragraph>
              O valor informado é maior que o restante à ser pago na conta,
              assim fazendo com que a cobrança fique maior. Para continuar,
              digite <strong>Confirmar pagamento</strong> no campo abaixo:
            </Typography>
            <TextField
              value={textConfirm.confirmPayment}
              label="Digite o texto"
              placeholder="Confirmar pagamento"
              helperText={textConfirm.error}
              error={!!textConfirm.error}
              onChange={(ev) =>
                setTextConfirm({ confirmPayment: ev.target.value })
              }
              fullWidth
            />
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setModalConfirmPayment(false)} color="primary">
            Cancelar
          </Button>
          <Button
            onClick={onPay}
            disabled={textConfirm.confirmPayment !== 'Confirmar pagamento'}
            color="primary"
            autoFocus
          >
            Ok, confirmar
          </Button>
        </DialogActions>
      </Dialog>

      {/* Dialog para encerramento em lote */}
      <Dialog
        fullWidth
        open={modalBatchTerminates}
        onClose={() => setModalBatchTerminates(false)}
      >
        <UIDialogTitle
          onClose={() => setModalBatchTerminates(false)}
          id="batch-terminates-dialog-title"
        >
          Encerramento em Lote ({selected.length} contas)
        </UIDialogTitle>
        <DialogContent>
          <Grid container direction="row" spacing={1}>
            <Grid item xs={12}>
              <Typography paragraph color="textSecondary" style={{ fontSize: 14 }}>
                Atenção: Ao encerrar estas contas, não será possível lançar novos pagamentos para as mesmas.
              </Typography>
              <Box
                style={{
                  backgroundColor: '#FFF3E0',
                  borderRadius: 8,
                  padding: 12,
                  marginBottom: 16,
                  border: '1px solid #FFE0B2',
                }}
              >
                <Typography variant="subtitle2" style={{ color: '#E65100', fontWeight: 600 }}>
                  Total a ser encerrado: {formattedCurrency(totalSelectedValue)}
                </Typography>
                <Typography variant="caption" style={{ color: '#E65100' }}>
                  {selected.length} conta(s) selecionada(s)
                </Typography>
              </Box>
              <Typography variant="caption" style={{ fontWeight: 600, color: '#666', marginBottom: 4, display: 'block' }}>
                Lista de contas a encerrar:
              </Typography>
              <List
                dense
                style={{
                  maxHeight: 180,
                  overflowY: 'auto',
                  border: '1px solid #E0E0E0',
                  borderRadius: 4,
                }}
              >
                {selectedBillsList.map((bill) => (
                  <ListItem key={bill.id} divider>
                    <ListItemText
                      primary={`#${bill.id} ${bill.name}`}
                      secondary={`Venc.: ${bill.dueDate || 'S/ Data'}`}
                      primaryTypographyProps={{ variant: 'body2', style: { fontWeight: 500 } }}
                    />
                    <Box display="flex" alignItems="center">
                      <Typography variant="body2" style={{ fontWeight: 'bold', marginRight: 8 }}>
                        {formattedCurrency(parseFloat(bill.value) - parseFloat(bill.valuePaid))}
                      </Typography>
                      <IconButton
                        size="small"
                        onClick={() => handleRemoveFromBatch(bill.id)}
                        title="Remover do lote"
                      >
                        <DeleteIcon fontSize="small" style={{ color: '#C43511' }} />
                      </IconButton>
                    </Box>
                  </ListItem>
                ))}
              </List>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setModalBatchTerminates(false)}
            color="primary"
            disabled={batchTerminatesLoading}
          >
            Cancelar
          </Button>
          <Button
            onClick={onBatchTerminates}
            style={{ backgroundColor: '#C43511', color: '#FFF' }}
            variant="contained"
            disabled={batchTerminatesLoading || selected.length === 0}
          >
            {batchTerminatesLoading && <CircularProgress size={20} style={{ color: '#FFF', marginRight: 8 }} />}
            Ok, encerrar {selected.length} conta(s)
          </Button>
        </DialogActions>
      </Dialog>
      <UIDialogConfirm
        open={alert}
        close={() => setAlert(false)}
        data={payInfo}
        messageSucess={payInfo.data && payInfo.data.message}
        messageError="Ops, ocorreu um erro ao pagar conta"
      />
      <UIDialogConfirm
        open={alertUpdate}
        close={() => setAlertUpdate(false)}
        data={updateInfo}
        setrequestinfo={setUpdateInfo}
        messageSucess="Conta atualizada com sucesso"
        messageError="Ops, ocorreu um erro ao pagar conta"
      />
      <UIDialogConfirm
        open={alertTerminates}
        close={() => setAlertTerminates(false)}
        data={setUpdateInfo}
        setrequestinfo={setUpdateInfo}
        messageSucess={terminatesInfo.data && terminatesInfo.data.message}
        messageError="Ops, ocorreu um erro ao pagar conta"
      />
    </>
  );
};

export default BillsToPay;
